import {
  FETCH_CAMPUSES_REQUEST,
  FETCH_CAMPUSES_SUCCESS,
  FETCH_CAMPUSES_FAILURE,
  RESET_CAMPUSES_FAILURE,
} from '../actions/fetchCampusActions';

export const initialState = {
  items: {},
  loading: false,
  error: null,
};

const updateSchoolCampuses = (state, payload) => {
  const { schoolId, campuses } = payload;
  return {
    ...state,
    [schoolId]: [...campuses],
  };
};

const campuses = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_CAMPUSES_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case FETCH_CAMPUSES_SUCCESS: {
      return {
        ...state,
        items: updateSchoolCampuses(state.items, payload),
        loading: false,
      };
    }
    case FETCH_CAMPUSES_FAILURE: {
      return {
        ...state,
        items: {},
        loading: false,
        error: payload,
      };
    }
    case RESET_CAMPUSES_FAILURE: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
};

export default campuses;
